/**
 * The medications a provider must know about before prescribing, as patients see
 * them on the intake form and their Profile.
 *
 * This is the patient-facing copy of the backend's MedicationScreen.java lists,
 * which are what actually flag a patient to their provider. Guillaume approved
 * those lists on 2026-10-14. Keep the two in step: a name added there should
 * appear here, so patients are asked about everything providers are alerted to.
 * Shorthand the backend also matches ("nitro", "NTG", "GTN") is left out here as
 * noise; class words ("opioid", "anticholinergic") likewise.
 */
export const FLAGGED_MEDICATIONS = [
  {
    id: "NITRATES",
    title: "Nitrates (for chest pain or heart conditions)",
    names: [
      "nitroglycerin (Nitrostat, Nitro-Dur, Nitrolingual, NitroMist, Minitran, Nitro-Bid)",
      "isosorbide mononitrate (Imdur, ISMO, Monoket)",
      "isosorbide dinitrate (Isordil, Dilatrate, BiDil)",
      "amyl nitrite (\"poppers\")",
      "nitroprusside (Nitropress)",
      "pentaerythritol tetranitrate, erythrityl tetranitrate",
    ],
  },
  {
    id: "DIGOXIN",
    title: "Digoxin (for heart rhythm or heart failure)",
    names: ["digoxin (Lanoxin, Digitek, Digox, Cardoxin)", "digitoxin"],
  },
  {
    id: "ANTICHOLINERGICS",
    title: "Anticholinergics",
    names: [
      "bladder: oxybutynin (Ditropan, Oxytrol, Gelnique), tolterodine (Detrol), solifenacin (Vesicare), darifenacin (Enablex), trospium (Sanctura), fesoterodine (Toviaz), flavoxate (Urispas)",
      "stomach and bowel: hyoscyamine (Levsin, Levbid), dicyclomine (Bentyl), propantheline, glycopyrrolate (Robinul, Cuvposa), atropine, scopolamine (Transderm Scop)",
      "Parkinson's: benztropine (Cogentin), trihexyphenidyl (Artane)",
      "inhalers: ipratropium (Atrovent), tiotropium (Spiriva), umeclidinium (Incruse), aclidinium (Tudorza)",
    ],
  },
  {
    id: "NARCOTICS",
    title: "Narcotic (opioid) pain medicine",
    names: [
      "oxycodone (OxyContin, Percocet, Roxicodone, Endocet)",
      "hydrocodone (Vicodin, Norco, Lortab, Hysingla, Zohydro)",
      "morphine (MS Contin, Kadian), codeine (Tylenol #3)",
      "hydromorphone (Dilaudid), fentanyl (Duragesic), methadone",
      "tramadol (Ultram, Ultracet), tapentadol (Nucynta), oxymorphone (Opana), meperidine (Demerol)",
      "buprenorphine (Suboxone, Subutex, Butrans, Belbuca), levorphanol, butorphanol, pentazocine",
    ],
  },
];

/**
 * Where on the intake form the notice belongs: the free-text medication list, and
 * the direct question added by the 2026-10-14 medication-screening migration.
 * Matched on wording, as the backend matches them; the questions have no fixed id.
 */
export const isMedicationQuestion = (questionText) => {
  const q = String(questionText || "").toLowerCase();
  return q.includes("list all medications") || q.includes("do you take any of these medications");
};
